<template>
  <div>
    <transition name="fade" mode="out-in">
        <router-view></router-view>
    </transition>
  </div>
</template>



<script>
  export default {
    created(){
      this.$store.dispatch("initAuth")
      
    }
  }
</script>

<style>
  .fade-enter{
    opacity: 0;
  }
  .fade-enter-active{
    transition: opacity .3s ease-out;
  }

  .fade-leave-active{
    transition: opacity .3s ease-out;
    opacity: 0;
  }
</style>


// WEBPACK FOOTER //
// src/App.vue